import React from "react";
import showIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-show-table.svg";
import hideIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-hide-table.svg";
import { LovableAwareShowHide } from "../../../../NewProductCategories/ProductDetailsLCA/components/LovableFlowControls";

export const ShowHide = ({ show, setShow }) => {
  return (
    <LovableAwareShowHide
      isOpen={show}
      onToggle={() => setShow(!show)}
      legacyShowSrc={showIcon}
      legacyHideSrc={hideIcon}
      size="lg"
      imgClassName="show-hide-icon"
    />
  );
};
